import React from 'react';
import {Layout} from 'antd';

const {Content} = Layout;


const Folha = (props) => {
    return(<Content
        id="folha"
        className="site-layout-background"
        style={{
          padding: 24,
          margin: 0,
          marginBottom: '23px',
          position: 'relative'
          
        }}
      >
          {props.children}
      </Content>);
}

export {Folha}